/**
@jsxRuntime
classic */
/** @jsx jsx */
import {jsx} from '@emotion/core'
import {DemoRequestsHeader} from '../components/ui/demo-requests'
import {useUserRoles} from '../utils/use-user-roles'
import {AUTHORIZED_ROLES_BY_SCREENS} from '../utils/constants'
import {getAuthByRole} from '../utils/get-screen-auth-by-role'
import NotFoundPage from '../components/not-found-page'
import {DemoAppointments} from '../components/demo-appointments'

const ENDPOINT = 'demos'

function DemoRequests() {
  const {roles} = useUserRoles()
  if (!getAuthByRole(AUTHORIZED_ROLES_BY_SCREENS.demoRequests, roles)) {
    return <NotFoundPage />
  }

  return (
    <DemoAppointments
      DemoAppointmentsHeader={DemoRequestsHeader}
      endpoint={ENDPOINT}
      showNewDemoButton={true}
      componentLabel="Demo Request"
      componentLabelPlural="Demo Requests"
    />
  )
}

export {DemoRequests}
